import { FC } from 'react';
import {
	Box,
	Flex,
	Modal,
	ModalBody,
	ModalContent,
	ModalOverlay,
	Text,
	VStack,
} from 'src/components/ui';

import FusionLoading from '../../../common/FusionLoading';

interface LaunchingCampaignModalProps {
	isOpen: boolean;
}

const LaunchingCampaignModal: FC<LaunchingCampaignModalProps> = ({
	isOpen,
}) => {
	return (
		<Modal isOpen={isOpen} onClose={() => {}} size="sm">
			<ModalOverlay zIndex={1800} />
			<ModalContent
				my="auto"
				containerProps={{
					zIndex: 1900,
				}}
			>
				<ModalBody
					display="flex"
					flexDirection="column"
					justifyContent="center"
					alignItems="center"
					gap={6}
					py={12}
				>
					<FusionLoading isLoading={isOpen} />
					<VStack w="100%" gap={2}>
						<Text fontWeight="medium" fontSize="md">
							Launching your campaign
						</Text>
						<Text fontSize="sm" color="gray.500">
							This may take up to 30 seconds
						</Text>
					</VStack>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};

export default LaunchingCampaignModal;
